import React, { Component } from "react";
import { connect } from "react-redux";
import * as dataActions from "../../../_actions/dataActions";
import * as userActions from "../../../_actions/userActions";
import Wrapper from "../../../_hoc/Wrapper";
import Select from "../../../_components/UI/Select";
import Input from "../../../_components/UI/Input";
import Button from "../../../_components/UI/Button";
import ReactPhoneInput from "react-phone-input-2";
import "./index.css";
import GenderSelect from "./GenderSelect";
import getCreatedBy from "../../../_selectors/dataSelectors/getCreatedBy";
import getProfilePicture from "../../../_selectors/userSelectors/getProfilePicture";
import getProfileCreatedBy from "../../../_selectors/userSelectors/getProfileCreatedBy";
import getMyMobileNumber from "../../../_selectors/userSelectors/getMyMobileNumber";

class MyInformation extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      prevState.name === "" ||
      prevState.selectedCreatedBy === null ||
      prevState.mobile === null
    ) {
      return {
        name: nextProps.name,
        selectedCreatedBy: nextProps.createdBy,
        mobile: nextProps.mobile === null ? "" : nextProps.mobile
      };
    } else {
      return null;
    }
  }
  state = {
    selectedCreatedBy: null,
    name: "",
    mobile: null
  };
  componentDidMount() {
    const { createdByOptions, getCreatedByData } = this.props;
    if (createdByOptions.length === 0) {
      getCreatedByData();
    }
  }
  changeGender = isFemale => {
    this.setState({ isFemale });
  };
  save = () => {
    const { isFemale, selectedCreatedBy, name, mobile } = this.state;
    const { updateProfile, onClose } = this.props;

    updateProfile({ createdBy: selectedCreatedBy.value, name, mobile });

    if (onClose) {
      onClose();
    }
  };
  render() {
    const { isFemale, selectedCreatedBy, name, mobile } = this.state;
    const { createdByOptions, image, createdBy } = this.props;
    return (
      <Wrapper>
        <h2 className="text-center">My Information</h2>
        <GenderSelect image={image} />
        <div className="form-group-one-unit">
          <div className="row">
            <div className="col-sm-12">
              <Input
                value={name}
                onChange={value => {
                  this.setState({ name: value });
                }}
                label={<Wrapper>Full Name</Wrapper>}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group form-group-custom form-control-clear">
                <label>Mobile Number</label>
                <div className="form-control-clear-wrap">
                  <ReactPhoneInput
                    value={mobile}
                    onChange={value => {
                      this.setState({ mobile: value });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <Select
                label={<Wrapper>Account Created By</Wrapper>}
                selected={selectedCreatedBy}
                options={createdByOptions}
                onChange={value => {
                  this.setState({ selectedCreatedBy: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <Button
              label="Continue"
              style={{ display: "block", margin: "0 auto", marginTop: "10px" }}
              primary
              small
              clean
              onClick={this.save}
            />
          </div>
        </div>
      </Wrapper>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  createdByOptions: getCreatedBy(state),
  image: getProfilePicture(state),
  createdBy: getProfileCreatedBy(state),
  mobile: getMyMobileNumber(state)
});
const mapDispatchToProps = dispatch => ({
  getCreatedByData: () => dispatch(dataActions.getCreatedBy()),
  updateProfile: payload => dispatch(userActions.updateMyInformation(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyInformation);



// WEBPACK FOOTER //
// ./src/_components/UI/MyInformation/index.js